import React from "react";

import SearchDropdown from "@cayuse/shared-react.components.search-dropdown";
import PropTypes from "prop-types";

const getDefaultRenderLabel = ({ tooltip, text }) => ({
	content: <span title={tooltip}>{text}</span>,
});

const ReviewSearchDropdown = ({ id, type, placeholder, prefetchedOptions, search, searchChange }) => {
	return (
		<SearchDropdown
			value={id}
			search={options => options}
			selection
			selectOnNavigation={false}
			forceSelection={false}
			selectOnBlur={false}
			onGetDataPromise={search}
			disabled={false}
			placeholder={placeholder}
			ariaLabel={placeholder}
			onChange={(value, selectedOptions) => searchChange(value, selectedOptions, type)}
			renderLabel={getDefaultRenderLabel}
			prefetchedOptions={prefetchedOptions}
			multiple={false}
			narrowCriteriaHint={{ show: true }}
			loadingIcon={
				<span
					className="loading-indicator"
					aria-hidden="true"
				>
					<span className="dot-flashing" />
				</span>
			}
			clearIcon={
				<span className="clear-icon">
					<svg
						height="20"
						width="20"
						viewBox="0 0 20 20"
						aria-hidden="true"
						focusable="false"
					>
						<path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
					</svg>
				</span>
			}
		/>
	);
};

ReviewSearchDropdown.propTypes = {
	id: PropTypes.string,
	type: PropTypes.string,
	placeholder: PropTypes.string,
	prefetchedOptions: PropTypes.array,
	search: PropTypes.func,
	searchChange: PropTypes.func,
};

export default ReviewSearchDropdown;
